export const uploadImageToCloudinary = async (file, folder = 'linkforest/profiles', userId = null) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
    formData.append('folder', folder);
    if (userId) {
      const timestamp = Date.now();
      formData.append('public_id', `${userId}_${timestamp}`);
    }

    fetch(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`, {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          reject(new Error(data.error.message));
        } else {
          const url = data.secure_url;
          resolve(url);
        }
      })
      .catch(error => reject(error));
  });
};

export const deleteImageFromCloudinary = async (imageUrl) => {
  try {
    const publicId = extractPublicIdFromUrl(imageUrl);
    if (!publicId) {
      return null;
    }

    return null;
  } catch (error) {
    console.warn('Error processing image deletion:', error.message);
    return null;
  }
};

const extractPublicIdFromUrl = (url) => {
  try {
    const urlParts = url.split('/');
    const filename = urlParts[urlParts.length - 1];
    const publicId = filename.split('.')[0];
    const folderMatch = url.match(/\/v\d+\/(.+)\//);
    if (folderMatch) {
      return folderMatch[1] + '/' + publicId;
    }
    return publicId;
  } catch (error) {
    return null;
  }
};

export const getDefaultImageUrl = () => {
  return process.env.REACT_APP_CLOUDINARY_DEFAULT_IMAGE || 
    'https://res.cloudinary.com/YOUR_CLOUD_NAME/image/upload/v1/linkforest/defaults/noImage.png';
};
